import { SvgIcon, SvgIconProps } from "@mui/material";

export const PaymentHistoryIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 22.737 18.526">
    <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_260_194)">
        <path d="M1 26.8199H31.01" stroke="#32B88E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M23.77 20.5C23.77 21.8807 24.8893 23 26.27 23C27.6507 23 28.77 21.8807 28.77 20.5V11.5C28.77 10.1193 27.6507 9 26.27 9C24.8893 9 23.77 10.1193 23.77 11.5V20.5Z"
          stroke="#32B88E"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M13.81 20.5C13.81 21.8807 14.9293 23 16.31 23C17.6907 23 18.81 21.8807 18.81 20.5V8.5C18.81 7.11929 17.6907 6 16.31 6C14.9293 6 13.81 7.11929 13.81 8.5L13.81 20.5Z"
          stroke="#32B88E"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M3.07 20.5C3.07 21.8807 4.18929 23 5.57 23C6.95071 23 8.07 21.8807 8.07 20.5L8.07 3.5C8.07 2.11929 6.95071 1 5.57 1C4.18929 1 3.07 2.11929 3.07 3.5L3.07 20.5Z"
          stroke="#32B88E"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_260_194">
          <rect width="32.01" height="27.82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
